export default __webpack_public_path__ + "static/media/logo.dd13be63.png";